import { render, staticRenderFns } from "./FileList.vue?vue&type=template&id=587275bc&scoped=true&"
import script from "./FileList.vue?vue&type=script&lang=js&"
export * from "./FileList.vue?vue&type=script&lang=js&"
import style0 from "./FileList.vue?vue&type=style&index=0&id=587275bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587275bc",
  null
  
)

export default component.exports